import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import CheckCircle from "@redotech/redo-web/icon-old/check-circle.svg";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";
import { containsImg } from "./step-rich-text-util";

export interface CloseChatState {
  message: string;
  messageHtml?: string;
  customTitle?: string;
}

export const CLOSE_CHAT = (
  Details: React.ComponentType<StepTypeDetailsProps<CloseChatState>>,
): StepType<CloseChatState, ModelStep.CloseChat> => ({
  Details: (props: StepTypeDetailsProps<CloseChatState>) =>
    React.createElement(Details, props),
  customTitle(state) {
    return state.customTitle;
  },
  description(state) {
    return state.message;
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: { message: "", messageHtml: undefined },
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  title: "Close chat",
  valid(state) {
    return !!state.message && !containsImg(state.messageHtml);
  },
  fromModel(model) {
    return {
      customTitle: model.customTitle,
      message: model.message,
      messageHtml: model.messageHtml,
    };
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.CLOSE_CHAT,
      message: state.message,
      messageHtml: state.messageHtml,
    };
  },
  Icon: CheckCircle,
});
